import { safeApiCall } from "api/common.service";
import { AppLogs } from "types/model.types";
import { authApi } from "./";

/**
 * Return a list of application logs.  Only global admin users can access this route.
 * @returns A promise that resolves to an array of application logs or void.
 */
export const getErrors = async (): Promise<void | AppLogs> => {
  const { data } = await authApi.post<AppLogs>("log/get");
  return data;
};
/**
 * Record an application error log. Open to all users.
 * @param error - The error to be logged. Can be a string, Error object, or any other type.
 */
export const logError = async (error: any, message = ""): Promise<void> => {
  let traceInfo: string;

  if (typeof error === "string") {
    traceInfo = error;
  } else if (error instanceof Error) {
    traceInfo = error.stack || error.message || error.toString();
  } else if (
    error &&
    typeof error === "object" &&
    "message" in error &&
    "stack" in error &&
    "componentStack" in error
  ) {
    traceInfo = `${error.message}\n\n${error.stack}\n\nComponent Stack:\n${error.componentStack}`;
  } else if (error && typeof error === "object") {
    try {
      traceInfo = JSON.stringify(error);
    } catch {
      traceInfo = "[Unserializable error object]";
    }
  } else {
    traceInfo = String(error);
  }
  try {
    traceInfo = `${message}: ${traceInfo}`;
    await safeApiCall(authApi.post("log/trace", { traceInfo }));
  } catch {
    // swallow any errors
  }
};
